import './FilterOptionThirdLevelCollections.scss';

import { createClsNameMap, stripHtml } from '@utils';

import type { FilterOptionItemSettings } from '@/features/filter-product-list/filter/FilterOptionItem';
import { FilterOptionItem } from '@/features/filter-product-list/filter/FilterOptionItem';
import FilterOptionItemButton from '@/features/filter-product-list/filter/FilterOptionItem/Button';
import FilterOptionItemLabel from '@/features/filter-product-list/filter/FilterOptionItem/Label';
import type {
  FilterOptionCollectionItemHookProps,
  FilterOptionCollectionItemProps,
} from '@/features/filter-product-list/filter/FilterOptionMultiLevelCollections';

export const clsNameMap = createClsNameMap({
  elements: {
    title: createClsNameMap(),
  },
})('filter-option-item-multilevel-collections-thirdlevel');

export type FilterOptionThirdLevelCollectionsItemProps = {
  collectionId: string;
  collectionHandle: string;
  useFilterOptionCollectionItem: (
    item: FilterOptionCollectionItemHookProps
  ) => FilterOptionCollectionItemProps;
  value: {
    tag: string;
    displayName: string;
    settings: FilterOptionItemSettings;
  };
};

export type FilterOptionThirdLevelCollectionsProps = {
  collectionId: string;
  collectionHandle: string;
  useFilterOptionCollectionItem: (
    item: FilterOptionCollectionItemHookProps
  ) => FilterOptionCollectionItemProps;
  options: Array<FilterOptionThirdLevelCollectionsItemProps['value']>;
};

const FilterOptionThirdLevelCollectionsItem = ({
  collectionHandle,
  value: { tag, displayName, settings },
  collectionId,
  useFilterOptionCollectionItem,
}: FilterOptionThirdLevelCollectionsItemProps) => {
  const { collectionUrlPath, isOptionItemSelected, handleSelectOptionItem } =
    useFilterOptionCollectionItem({
      collectionId,
      collectionHandle,
      tag,
    });

  if (!stripHtml(displayName)) return null;

  return (
    <FilterOptionItem as='li' className={clsNameMap.elm('title')}>
      <FilterOptionItemButton
        as='link'
        isSelected={isOptionItemSelected}
        label={<FilterOptionItemLabel settings={settings} label={displayName} />}
        link={collectionUrlPath}
        onClick={(e: Event) => handleSelectOptionItem(e)}
      />
    </FilterOptionItem>
  );
};

const FilterOptionThirdLevelCollections = ({
  options,
  collectionId,
  collectionHandle,
  useFilterOptionCollectionItem,
}: FilterOptionThirdLevelCollectionsProps) => {
  return (
    <ul className={clsNameMap.root()}>
      {options.map((option) => (
        <FilterOptionThirdLevelCollectionsItem
          key={option.tag}
          collectionId={collectionId}
          collectionHandle={collectionHandle}
          useFilterOptionCollectionItem={useFilterOptionCollectionItem}
          value={option}
        />
      ))}
    </ul>
  );
};

export default FilterOptionThirdLevelCollections;
